import React from 'react';
import ChordParser from '~/sites/music/utils/ChordParser';
import { getLcn } from '~/utils/labeled-classnames';
import ChartEditButtons from './ChartEditButtons';
import { Chip } from '@mui/material';
import { FaArrowRightLong } from 'react-icons/fa6';

export default function ChartEditControls() {
  const lcn = getLcn({
    chartEditControls: ''
  });

  function symbolKey() {
    let chordParser = new ChordParser()

    return (
      chordParser.symbolKey().map(
        (set, i) => (
          <Chip
            key={i}
            size="small"
            label={<>{set[0]} <FaArrowRightLong className="divider inline mx-1" /> {set[1]}</>}
            className="symbol-key-item mr-2 mb-1"
          />
        )
      )
    )
  }

  return (
    <div className={lcn.chartEditControls}>
      <div className="flex flex-wrap">
        <div className="w-full xl:w-2/3 mb-2">
          <ChartEditButtons />
        </div>
        <div className="w-full xl:w-1/3 mb-2">
          <div className="flex flex-wrap items-center gap-1">
            <span> Chord Symbol Key: </span>
            {symbolKey()}
          </div>
        </div>
      </div>
    </div>
  )
}